import { SET_WIDGET_INFO } from '../actions/types';

export default function widgetInfo(state = {}, action) {
	if (!action.error && action.payload) {
		if (action.type && action.type === SET_WIDGET_INFO) {
			const {
				payload: {
					accountId,
					pageAlias,
					vehicleAccountId,
					vehicleCategory,
					vehicleType,
					vehicleId
				}
			} = action;
			return {
				accountId,
				pageAlias,
				vehicleAccountId,
				vehicleCategory,
				vehicleType,
				vehicleId
			};
		}
	}

	return state;
}
